"use strict";

function _interopDefault(t) {
  return t && "object" == typeof t && "default" in t ? t.default : t;
}
var React = _interopDefault(require("react")),
  styles = {
    wrapper: {
      width: "100%",
      height: "100%",
      position: "relative"
    },
    frame: {
      width: "100%",
      height: "100%",
      position: "absolute"
    }
  },
  Carousel = function (e) {
    function t(t) {
      e.call(this, t), this.state = {
        frames: [].concat(t.frames || t.children || []),
        current: 0
      }, this.mounted = !1, this.debounceTimeoutId = null, this.onTouchStart = this.onTouchStart.bind(this), this.onTouchMove = this.onTouchMove.bind(this), this.onTouchEnd = this.onTouchEnd.bind(this), this.onResize = this.onResize.bind(this), this.autoSlide = this.autoSlide.bind(this), this.prev = this.prev.bind(this), this.next = this.next.bind(this), !1 === t.loop && t.auto && console.warn("[re-carousel] Auto-slide only works in loop mode.");
    }
    return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.componentDidMount = function () {
      this.mounted = !0, this.prepareAutoSlide(), this.hideFrames(), this.refs.wrapper.addEventListener("touchmove", this.onTouchMove, {
        capture: !0
      }), this.refs.wrapper.addEventListener("touchend", this.onTouchEnd, {
        capture: !0
      }), window.addEventListener("resize", this.onResize);
    }, t.prototype.componentWillUnmount = function () {
      this.mounted = !1, this.clearAutoTimeout(), this.refs.wrapper.removeEventListener("touchmove", this.onTouchMove, {
        capture: !0
      }), this.refs.wrapper.removeEventListener("touchend", this.onTouchEnd, {
        capture: !0
      }), window.removeEventListener("resize", this.onResize);
    }, t.prototype.componentDidUpdate = function (t, e) {
      this.state.frames.length && this.state.frames.length !== e.frames.length && (this.hideFrames(), this.prepareAutoSlide());
    }, t.getDerivedStateFromProps = function (t, e) {
      var r = [].concat(t.frames || t.children || []),
        s = {
          frames: r
        };
      return r.length && r.length !== e.frames.length && (s.current = 0), s;
    }, t.prototype.hideFrames = function () {
      for (var t = 1; t < this.state.frames.length; t++) this.refs["f" + t].style.opacity = 0;
    }, t.prototype.onResize = function () {
      var t = this;
      clearTimeout(this.debounceTimeoutId), this.debounceTimeoutId = setTimeout(function () {
        t.updateFrameSize(function () {
          t.prepareSiblingFrames();
        });
      }, 25);
    }, t.prototype.onTouchStart = function (t) {
      if (!(this.state.total < 2)) {
        this.clearAutoTimeout(), this.updateFrameSize(), this.prepareSiblingFrames();
        var e = t.touches && t.touches[0] || t,
          r = e.pageX,
          s = e.pageY;
        this.setState({
          startX: r,
          startY: s,
          deltaX: 0,
          deltaY: 0
        }), this.refs.wrapper.addEventListener("mousemove", this.onTouchMove, {
          capture: !0
        }), this.refs.wrapper.addEventListener("mouseup", this.onTouchEnd, {
          capture: !0
        }), this.refs.wrapper.addEventListener("mouseleave", this.onTouchEnd, {
          capture: !0
        });
      }
    }, t.prototype.onTouchMove = function (t) {
      if (!(t.touches && 1 < t.touches.length)) {
        this.clearAutoTimeout();
        var e = t.touches && t.touches[0] || t,
          r = e.pageX,
          s = e.pageY,
          i = r - this.state.startX,
          a = s - this.state.startY;
        this.setState({
          deltaX: i,
          deltaY: a
        }), "x" === this.props.axis && Math.abs(i) > Math.abs(a) && (t.preventDefault(), t.stopPropagation()), "y" === this.props.axis && Math.abs(a) > Math.abs(i) && (t.preventDefault(), t.stopPropagation()), this.props.loop || (this.state.current === this.state.frames.length - 1 && (i < 0 && (i /= 3), a < 0 && (a /= 3)), 0 === this.state.current && (0 < i && (i /= 3), 0 < a && (a /= 3))), this.moveFramesBy(i, a);
      }
    }, t.prototype.onTouchEnd = function () {
      var t = this,
        e = this.decideEndPosition();
      e && this.transitFramesTowards(e), this.refs.wrapper.removeEventListener("mousemove", this.onTouchMove, {
        capture: !0
      }), this.refs.wrapper.removeEventListener("mouseup", this.onTouchEnd, {
        capture: !0
      }), this.refs.wrapper.removeEventListener("mouseleave", this.onTouchEnd, {
        capture: !0
      }), setTimeout(function () {
        return t.prepareAutoSlide();
      }, this.props.duration);
    }, t.prototype.decideEndPosition = function () {
      var t = this.state,
        e = t.deltaX;
      void 0 === e && (e = 0);
      var r = t.deltaY;
      void 0 === r && (r = 0);
      var s = t.current,
        i = t.frames,
        a = this.props,
        o = a.axis,
        n = a.loop,
        p = a.minMove;
      switch (o) {
        case "x":
          if (!1 === n) {
            if (0 === s && 0 < e) return "origin";
            if (s === i.length - 1 && e < 0) return "origin";
          }
          return Math.abs(e) < p ? "origin" : 0 < e ? "right" : "left";
        case "y":
          if (!1 === n) {
            if (0 === s && 0 < r) return "origin";
            if (s === i.length - 1 && r < 0) return "origin";
          }
          return Math.abs(r) < p ? "origin" : 0 < r ? "down" : "up";
      }
    }, t.prototype.moveFramesBy = function (t, e) {
      var r = this.state.movingFrames,
        s = r.prev,
        i = r.current,
        a = r.next,
        o = this.state,
        n = o.frameWidth,
        p = o.frameHeight;
      switch (this.props.axis) {
        case "x":
          translateXY(i, t, 0), t < 0 ? translateXY(a, t + n, 0) : translateXY(s, t - n, 0);
          break;
        case "y":
          translateXY(i, 0, e), e < 0 ? translateXY(a, 0, e + p) : translateXY(s, 0, e - p);
      }
    }, t.prototype.prepareAutoSlide = function () {
      var t = this;
      if (!(this.state.frames.length < 2) && (this.clearAutoTimeout(), this.updateFrameSize(function () {
        t.prepareSiblingFrames();
      }), this.mounted && this.props.loop && this.props.auto)) {
        var e = setTimeout(this.autoSlide, this.props.interval);
        this.setState({
          slider: e
        });
      }
    }, t.prototype.autoSlide = function (t) {
      var e = this;
      switch (this.clearAutoTimeout(), t) {
        case "prev":
          this.transitFramesTowards("x" === this.props.axis ? "right" : "down");
          break;
        case "next":
        default:
          this.transitFramesTowards("x" === this.props.axis ? "left" : "up");
      }
      setTimeout(function () {
        return e.prepareAutoSlide();
      }, this.props.duration);
    }, t.prototype.next = function () {
      var t = this.state,
        e = t.current,
        r = t.frames;
      if (!this.props.loop && e === r.length - 1) return !1;
      this.autoSlide("next");
    }, t.prototype.prev = function () {
      if (!this.props.loop && 0 === this.state.current) return !1;
      var t = this.state.movingFrames,
        e = t.prev;
      e === t.next && ("x" === this.props.axis ? translateXY(e, -this.state.frameWidth, 0, 0) : translateXY(e, 0, -this.state.frameHeight, 0), e.getClientRects()), this.autoSlide("prev");
    }, t.prototype.clearAutoTimeout = function () {
      clearTimeout(this.state.slider);
    }, t.prototype.updateFrameSize = function (t) {
      var e = window.getComputedStyle(this.refs.wrapper),
        r = e.width,
        s = e.height;
      this.setState({
        frameWidth: parseFloat(r.split("px")[0]),
        frameHeight: parseFloat(s.split("px")[0])
      }, t);
    }, t.prototype.getSiblingFrames = function () {
      return {
        current: this.refs["f" + this.getFrameId()],
        prev: this.refs["f" + this.getFrameId("prev")],
        next: this.refs["f" + this.getFrameId("next")]
      };
    }, t.prototype.prepareSiblingFrames = function () {
      var t = this.getSiblingFrames();
      return this.props.loop || (0 === this.state.current && (t.prev = void 0), this.state.current === this.state.frames.length - 1 && (t.next = void 0)), this.setState({
        movingFrames: t
      }), translateXY(t.current, 0, 0), "x" === this.props.axis ? (translateXY(t.prev, -this.state.frameWidth, 0), translateXY(t.next, this.state.frameWidth, 0)) : (translateXY(t.prev, 0, -this.state.frameHeight), translateXY(t.next, 0, this.state.frameHeight)), t;
    }, t.prototype.getFrameId = function (t) {
      var e = this.state,
        r = e.frames,
        s = e.current,
        i = r.length;
      switch (t) {
        case "prev":
          return (s - 1 + i) % i;
        case "next":
          return (s + 1) % i;
        default:
          return s;
      }
    }, t.prototype.transitFramesTowards = function (t) {
      var e = this,
        r = this.state.movingFrames,
        s = r.prev,
        i = r.current,
        a = r.next,
        o = this.props,
        n = o.duration,
        p = o.axis,
        h = o.onTransitionEnd,
        u = this.state.current;
      switch (t) {
        case "up":
          translateXY(i, 0, -this.state.frameHeight, n), translateXY(a, 0, 0, n), u = this.getFrameId("next");
          break;
        case "down":
          translateXY(i, 0, this.state.frameHeight, n), translateXY(s, 0, 0, n), u = this.getFrameId("prev");
          break;
        case "left":
          translateXY(i, -this.state.frameWidth, 0, n), translateXY(a, 0, 0, n), u = this.getFrameId("next");
          break;
        case "right":
          translateXY(i, this.state.frameWidth, 0, n), translateXY(s, 0, 0, n), u = this.getFrameId("prev");
          break;
        default:
          translateXY(i, 0, 0, n), "x" === p ? (translateXY(s, -this.state.frameWidth, 0, n), translateXY(a, this.state.frameWidth, 0, n)) : "y" === p && (translateXY(s, 0, -this.state.frameHeight, n), translateXY(a, 0, this.state.frameHeight, n));
      }
      h && setTimeout(function () {
        return h(e.getSiblingFrames());
      }, n), this.setState({
        current: u
      });
    }, t.prototype.render = function () {
      var r = this,
        t = this.state,
        s = t.frames,
        i = t.current,
        e = this.props,
        a = e.widgets,
        o = e.axis,
        n = e.loop,
        p = e.auto,
        h = e.interval,
        u = objectAssign(styles.wrapper, this.props.style);
      return React.createElement("div", {
        style: u
      }, React.createElement("div", {
        ref: "wrapper",
        style: objectAssign({
          overflow: "hidden"
        }, u),
        onTouchStart: this.onTouchStart,
        className: this.props.className,
        onMouseDown: this.onTouchStart
      }, s.map(function (t, e) {
        var r = objectAssign({
          zIndex: 99 - e
        }, styles.frame);
        return React.createElement("div", {
          ref: "f" + e,
          key: e,
          style: r
        }, t);
      }), this.props.frames && this.props.children), a && [].concat(a).map(function (t, e) {
        return React.createElement(t, {
          key: e,
          index: i,
          total: s.length,
          prevHandler: r.prev,
          nextHandler: r.next,
          axis: o,
          loop: n,
          auto: p,
          interval: h
        });
      }));
    }, t;
  }(React.Component);
function translateXY(t, e, r, s) {
  void 0 === s && (s = 0), t && (t.style.opacity = "1", t.style.transitionDuration = s + "ms", t.style.webkitTransitionDuration = s + "ms", t.style.transform = "translate(" + e + "px, " + r + "px)", t.style.webkitTransform = "translate(" + e + "px, " + r + "px) translateZ(0)");
}
function objectAssign(t) {
  for (var e = arguments, r = Object(t), s = 1; s < arguments.length; s++) {
    var i = e[s];
    if (null != i) for (var a in i) i.hasOwnProperty(a) && (r[a] = i[a]);
  }
  return r;
}
Carousel.defaultProps = {
  axis: "x",
  auto: !1,
  loop: !1,
  interval: 5e3,
  duration: 300,
  minMove: 42
}, module.exports = Carousel;